<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 我的优惠券 -->
          <div class="ttshop_coupon min_h">
            <div class="ttshop_couponnav">
              <ul class="clearfloat">
                <!-- <li class="active">全部优惠券</li> -->
                <li
                  @click="usecoupon(0)"
                  :class="activeIndex == 0 ? 'active' : ''"
                >
                  未使用
                </li>
                <li
                  @click="usecoupon(1)"
                  :class="activeIndex == 1 ? 'active' : ''"
                >
                  已使用
                </li>
                <li
                  @click="usecoupon(2)"
                  :class="activeIndex == 2 ? 'active' : ''"
                >
                  已过期
                </li>
              </ul>
            </div>
            <!-- 暂无优惠券显示 -->
            <div class="ttshop_zuxiaofei" v-if="couponlist.length == 0">
              <img
                class="img-default"
                src="../../assets/images/ttshop_zanwu.png"
                alt=""
              />
              <p>您目前暂无任何消费券</p>
            </div>

            <div class="ttshop_couponcon">
              <ul class="clearfloat">
                <!-- <li class="clearfloat">
									<div class="ttshop_couponmoney">
										<p>￥<span>98</span></p>
									</div>
									<div class="ttshop_couponconter">
										<h5>20元购物券</h5>
										<p class="ttshop_couponmj">满<strong>199</strong>使用</p>
										<p class="ttshop_coupontime">有效期： 2020.12.12-2020.12.12</p>
										<p class="ttshop_couponshop">商家：波司登羽绒服（海淀点）</p>
									</div>
									<div class="ttshop_couponright">
										<p>立 即 使 用</p>
									</div>
								</li>
								<li class="clearfloat">
									<div class="ttshop_couponmoney">
										<p>￥<span>98</span></p>
									</div>
									<div class="ttshop_couponconter">
										<h5>20元购物券</h5>
										<p class="ttshop_couponmj">满<strong>199</strong>使用</p>
										<p class="ttshop_coupontime">有效期： 2020.12.12-2020.12.12</p>
										<p class="ttshop_couponshop">商家：波司登羽绒服（海淀点）</p>
									</div>
									<div class="ttshop_couponright">
										<p>立 即 使 用</p>
									</div>
								</li>
								<li class="clearfloat">
									<div class="ttshop_couponmoney">
										<p>￥<span>98</span></p>
									</div>
									<div class="ttshop_couponconter">
										<h5>20元购物券</h5>
										<p class="ttshop_couponmj">满<strong>199</strong>使用</p>
										<p class="ttshop_coupontime">有效期： 2020.12.12-2020.12.12</p>
										<p class="ttshop_couponshop">商家：波司登羽绒服（海淀点）</p>
									</div>
									<div class="ttshop_couponright">
										<p>立 即 使 用</p>
									</div>
								</li> -->
                <!-- 此expire类名为过期或已使用 -->
                <!-- <li class="clearfloat expire">
									<div class="ttshop_couponmoney">
										<p>￥<span>980</span></p>
									</div>
									<div class="ttshop_couponconter">
										<h5>980元购物券</h5>
										<p class="ttshop_couponmj">满<strong>1099</strong>使用</p>
										<p class="ttshop_coupontime">有效期： 2020.12.12-2020.12.12</p>
										<p class="ttshop_couponshop">商家：波司登羽绒服（海淀点）</p>
									</div>
									<div class="ttshop_couponright">
										<p>立 即 使 用</p>
									</div>
								</li> -->
                <li
                  v-for="(item, index) in couponlist"
                  :key="index"
                  class="clearfloat"
                  :class="item.is_expire == 1 ? 'expire' : ''"
                >
                  <div class="ttshop_couponmoney">
                    <p>
                      ￥<span
                        >{{ item.sub_price
                        }}<span class="decimal">.{{ item.sub_decimal }}</span>
                      </span>
                    </p>
                  </div>
                  <div class="ttshop_couponconter">
                    <h5>{{ item.title }}</h5>
                    <p class="ttshop_couponmj">
                      满<strong>{{ item.min_price }}</strong
                      >使用
                    </p>
                    <p class="ttshop_coupontime">
                      有效期:{{ item.begin_time }}-{{ item.end_time }}
                    </p>
                    <p class="ttshop_couponshop">
                      商家：{{ item.mch_id > 0 ? item.mch_name : "平台自营" }}
                    </p>
                  </div>
                  <div
                    class="ttshop_couponright"
                    v-if="item.status == 0"
                    @click="makeuse(item)"
                  >
                    <p>立 即 使 用</p>
                  </div>
                  <div class="ttshop_couponright" v-if="item.status == 1">
                    <p>已 使 用</p>
                  </div>
                  <div class="ttshop_couponright" v-if="item.status == 2">
                    <p>已 过 期</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      couponlist: [],
      activeIndex: 0,
    };
  },
  mounted() {},
  created() {
    this.personalcoupon(0);
  },
  methods: {
    makeuse(item) {
      let cat_ids = "";
      if (item.cat_id_list) {
        cat_ids = item.cat_id_list.join(",");
      }
      let param;
      if (item.appoint_type == 1) {
       param = {
          is_coupon: 1,
          cat_id: cat_ids,
          mch_id: item.mch_id,
          mch_cat_id: cat_ids,
        };
      } else {
        param = {
          is_coupon: 1,
          goods_id: item.goods_id_list,
          mch_id: item.mch_id,
          mch_cat_id: cat_ids,
        };
      }
      // let param = {
      //   is_coupon: 1,
      //   cat_id: cat_ids,
      //   goods_id: item.goods_id_list,
      //   mch_id: item.mch_id,
      //   mch_cat_id: cat_ids,
      // };
      this.$router.push({
        path: "/list",
        query: param,
      });
    },
    //顶部导航栏的切换
    usecoupon(status) {
      this.activeIndex = status;
      this.personalcoupon(status);
    },
    //获取优惠券的信息 status 0是未使用  1是已使用  2是已过期
    async personalcoupon(statuss) {
      let res = await this.$api.personalcoupon({
        status: statuss,
      });
      if (res.code == 0) {
        for (var i = 0; i < res.data.list.length; i++) {
          if (res.data.list[i].sub_price.indexOf(".") != -1) {
            let price = res.data.list[i].sub_price.split(".");
            res.data.list[i].sub_price = price[0];
            res.data.list[i].sub_decimal = price[1];
          } else {
            res.data.list[i].sub_decimal = "00";
          }
        }
        this.couponlist = res.data.list;
      } else {
        this.couponlist = [];
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_useright {
  min-width: 990px;
  max-width: 1025px;
  width: auto;
}
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .ttshop_couponnav {
    width: 100%;
    margin-bottom: 20px;
    ul {
      li {
        float: left;
        cursor: pointer;
        padding-bottom: 10px;
        margin-right: 24px;
        box-sizing: border-box;
        position: relative;
        font-size: 12px;
        line-height: 12px;
        color: #333;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        &:last-child {
          margin-right: 0;
        }
        &::before {
          content: "";
          width: 00%;
          height: 2px;
          background: #ff0e25;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          -o-transform: translateX(-50%);
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
        }
        &:hover {
          color: #ff0e25;
        }
        &:hover::before {
          width: 100%;
        }
        &.active {
          color: #ff0e25;
        }
        &.active:before {
          width: 100%;
        }
      }
    }
  }
  .ttshop_zuxiaofei {
    width: 100%;
    padding-top: 150px;
    display: none;
    box-sizing: border-box;
    img {
      display: block;
      width: 93px;
      height: 80px;
      margin: 0 auto 20px;
    }
    p {
      font-size: 16px;
      color: #333;
      text-align: center;
    }
  }
  .ttshop_couponcon {
    width: 100%;
    ul {
      width: 100%;
      li {
        float: left;
        // width: 455px;
        height: 120px;
        cursor: pointer;
        margin-right: 32px;
        margin-bottom: 20px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        .ttshop_couponmoney {
          float: left;
          //   width: 148px;
          min-width: 148px;
          height: 120px;
          line-height: 120px;
          background: url(../../assets/images/ttshop_youhui.png) center
            no-repeat;
          background-size: 100% 100%;
          p {
            font-size: 24px;
            color: #fff;
            text-align: center;
            padding: 0 5px;
            span {
              font-size: 38px;
              color: #fff;
              font-weight: 500;
              line-height: 38px;
            }
            .decimal {
              font-size: 28px;
            }
          }
        }
        .ttshop_couponconter {
          float: left;
          width: 267px;
          height: 120px;
          border: 1px solid #ff0e25;
          border-left: 0;
          border-right: 0;
          padding: 16px 16px 14px 16px;
          box-sizing: border-box;
          h5 {
            font-size: 14px;
            color: #333;
            font-weight: 600;
            line-height: 14px;
            margin-bottom: 8px;
          }
          .ttshop_couponmj {
            font-size: 12px;
            color: #666;
            line-height: 12px;
            margin-bottom: 22px;
            font-weight: 400;
            strong {
              font-weight: 400;
              font-size: 12px;
              color: #666;
            }
          }
          .ttshop_coupontime {
            font-size: 12px;
            color: #666;
            line-height: 12px;
            font-weight: 400;
            margin-bottom: 5px;
          }
          .ttshop_couponshop {
            font-size: 12px;
            color: #666;
            line-height: 12px;
            font-weight: 400;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .ttshop_couponright {
          float: left;
          width: 40px;
          height: 120px;
          border: 1px solid #ff4300;
          padding: 28px 11px;
          box-sizing: border-box;
          border-radius: 0 2px 2px 0;
          p {
            font-size: 12px;
            color: #ff0e25;
            font-weight: 600;
            writing-mode: vertical-lr;
            text-align: center;
          }
        }
        &.expire {
          cursor: default;
          .ttshop_couponmoney {
            background: url(../../assets/images/ttshop_gqyouhui.png) center
              no-repeat;
            background-size: 100% 100%;
          }
          .ttshop_couponconter {
            width: 307px;
            border-right: 1px solid #cccccc;
            border-color: #cccccc;
            border-radius: 0 2px 2px 0;
          }
          .ttshop_couponright {
            display: none;
          }
        }
      }
    }
  }
}
</style>
